import React from 'react';
import '../styles/buttons.css';

const Button = ({ text, handleClick, type }) =>
  <button className={`btn ${type ? `btn--${type}` : ''}`} onClick={handleClick}>
    {text}
  </button>;

export default Button;
